<div class="flex flex-col w-full h-full justify-center">
  <div class="flex w-full max-h-full flex-col items-center gap-4 p-8">
    <img
      class="w-full"
      [ngSrc]="'../../../../assets/lifemap_welcome.webp'"
      [width]="316"
      [height]="184"
      [alt]="'Book with coffee and pen'"
      priority
    />
    <p class="text-2xl font-bold">{{ blockLifemap.data.config.welcome.title }}</p>
    <div class="flex items-center justify-center gap-8">
      <pl-icon
        [name]="PlIcon.briefcase"
        class="h-14 w-14 rounded-full p-4"
        [ngStyle]="{ backgroundColor: plEventsColor[LifemapType.work].eventColor.primary }"
      />
      <pl-icon
        [name]="PlIcon.heart_wind"
        class="h-14 w-14 rounded-full p-4"
        [ngStyle]="{ backgroundColor: plEventsColor[LifemapType.nonWork].eventColor.primary }"
      />
      <pl-icon
        [name]="PlIcon.moon"
        class="h-14 w-14 rounded-full p-4"
        [ngStyle]="{ backgroundColor: plEventsColor[LifemapType.sleep].eventColor.primary }"
      />
    </div>

    <ol *ngIf="lifemapTips.length > 0" class="list-inside text-pl-gray-450 list-decimal space-y-4 mt-4">
      <li *ngFor="let tip of lifemapTips" [innerHTML]="tip"></li>
      <!--      <li><span class="font-bold">START at DAY 1</span>: look back on your day and sequentially fill out the day.</li>-->
      <!--      <li>Answer the 10 <span class="font-bold">'HOW IT FELT'</span> questions for each mapped activity.</li>-->
      <!--      <li>Don’t leave <span class="font-bold">ANY TIME GAPS</span>.</li>-->
      <!--      <li>Complete each day,<span class="font-bold"> ADJUSTING YOUR SLEEP HOURS</span> as required.</li>-->
      <!--      <li>-->
      <!--        If you <span class="font-bold">MISS A DAY</span>, that's ok - just start again on the following day. Always log-->
      <!--        the current day.-->
      <!--      </li>-->
    </ol>
  </div>
</div>
